import { Loader } from '../../components/Loader/Loader';
import styles from './Header.module.scss';
import MenuIcon from "@mui/icons-material/Menu";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setCompact, selectIsCompact } from '../../slices/compact.slice';
import { useNavigate } from 'react-router-dom';
export default function Header() {
  const isUserConfigDataLoading = false;
  const dispatch = useDispatch();
  const isCompact = useSelector(selectIsCompact);
  const navigate = useNavigate();
  // const [isCompact, setIsCompact] = useState(true);
  useEffect(() => {
    const storedState = localStorage.getItem("sidebarState");
    dispatch(setCompact(storedState ? JSON.parse(storedState) : true));
  }, []);

  const openSidebar = () => {
    dispatch(setCompact(false));
    localStorage.setItem("sidebarState", JSON.stringify(false));
  };

  const closeSidebar = () => {
    dispatch(setCompact(true));
    localStorage.setItem("sidebarState", JSON.stringify(true));
  };
  return (
    <div className={styles.headerComponentWrapper}>
      <div className={styles.sidebar_menu_icon_wrapper}>
        {isCompact ? (
          <MenuIcon
            sx={{
              cursor: "pointer",
            }}
            onClick={() => openSidebar()}
          />
        ) : (
          <ArrowBackIcon
            sx={{
              cursor: "pointer",
            }}
            onClick={() => closeSidebar()}
          />
        )}
      </div>
      {isUserConfigDataLoading ? (
        <Loader type='button' />
      ) : (
        <div className={styles.logoWrapper}>
          <img src="https://static.wixstatic.com/media/d8fded_81c3bab6c50a4faa89edb560c844c47a%7Emv2.png/v1/fill/w_192%2Ch_192%2Clg_1%2Cusm_0.66_1.00_0.01/d8fded_81c3bab6c50a4faa89edb560c844c47a%7Emv2.png" alt='Logo' onClick={() => navigate("/")} />
          <h6 onClick={() => navigate("/")}>Harshberger</h6>
          <hr />
        </div>
      )}
    </div>
  );
}
